import React, {Component} from "react";
import PropTypes from "prop-types";
import "bootstrap";
import {connect} from "react-redux";
import Routes, { formObjectToRouteMap } from "../Navigation/Routes";
import i18next from "@mnjsplatform/data/lib/localization/i18";
import MnSpinner from "@mnjsplatform/components/lib/common/MnSpinner";
import {loadAppParameters} from "../../actions/AppActions";
import {withRouter} from "react-router";
import * as actions from "../../actions/loginActions";
import Menu from "../Navigation/Menu";
import Alert from "@mnjsplatform/components/lib/common/Alert";

class Master extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isAuthenticated: false,
            isError: false,
            errorText: ""
        };
    }

    componentDidMount() {
        this.loadAppParams();
    }

    retry = ()=> {
        this.loadAppParams();
    };

    loadAppParams = () => {
        this.props.dispatch(loadAppParameters(this.props.history))
          .then(() => {

              if(!this.props.homeState || !this.props.homeState.appParams || !this.props.homeState.appParams.currentCommand)
                  return;

              if(!this.props.homeState.appParams.currentCommand.Param1)
                  return;

              const objectName = this.props.homeState.appParams.currentCommand.Param1;

              const target = formObjectToRouteMap[objectName];
              if (!target)
                  return;

              this.props.history.replace('/' + target.link);
          })
    };

    signOut = () => {
        this.props.dispatch(actions.logout(this.props.history));
    };

    render() {

        if (!this.props.homeState || (!this.props.homeState.inOperation && !this.props.homeState.isLoaded && !this.props.homeState.isError))
            return <div/>;

        if (!this.props.homeState.isLoaded && this.props.homeState.inOperation)
            return <div><MnSpinner active/></div>;

        if (this.props.homeState.isError)
            return (<div>
                <div className="alert alert-danger" role="alert">{i18next.t('AppError')}<b>{this.props.homeState.errorText}</b>
                    <button className="btn btn-primary" onClick={this.retry} style={{marginLeft: 10}}>{i18next.t('Retry')}</button>
                    <button className="btn btn-primary" onClick={this.signOut} style={{marginLeft: 10}}>{i18next.t('Exit')}</button>
                </div>
            </div>);

        return (
            <div>
                {this.props.inOpState && <MnSpinner active /> }
                <Alert/>
                <Menu/>
                <div style={{marginLeft:"15px", marginRight: "15px"}}>
                <Routes/>
                </div>
            </div>
        );
    }
}

Master.propTypes = {
    dispatch: PropTypes.func.isRequired,
    homeState: PropTypes.object,
    history: PropTypes.object
};

Master.defaultProps = {
    //myProp: <defaultValue>
};

function mapStateToProps(state) {
    return {
        homeState: state.appState,
        inOpState: state.inOperationState
    };
}

export default withRouter(connect(mapStateToProps)(Master));